import cascader from './cascader.vue'

cascader.install = function(Vue) {
  Vue.component(cascader.name, cascader)
}

export default cascader
